import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CreateVideoRequest } from './create-video-request.model';
import { ViewVideoRequest } from './view-video-request.model';

@Injectable()
export class VideoRequestsService {
    private endpoint = 'video-requests';

    constructor(private http: HttpClient) {
    }

    async all(): Promise<ViewVideoRequest[]> {
        return this.http.get<ViewVideoRequest[]>(this.endpoint).toPromise();
    }

    async get(requestId: string): Promise<ViewVideoRequest> {
        return this.http.get<ViewVideoRequest>(this.endpoint, {
            params: new HttpParams().set('id', requestId)
        }).toPromise();
    }

    put(videoRequest: CreateVideoRequest): Observable<number> {
        return this.http.put<number>(this.endpoint, videoRequest);
    }
}
